export default __webpack_public_path__ + "static/media/icon-home.e73abf50.svg";